import React, { useState, useEffect } from "react";
import Fade from "react-reveal/Fade";
import { Tooltip } from "antd";

import texts from "../../texts.json";

import "./style.css";

import imgBlock from "../../images/botticino.png";
import gfBackground from "../../images/gf.png";

const MarbleComponent = (props) => {
  const index = props.index;
  const [selected, setSelected] = useState("one");
  const [tooltipVisible, setTooltipVisible] = useState(true);

  useEffect(() => {
    document.getElementById(selected).classList.add("selected");
    document.getElementById("medal-block").classList.add(selected + "-img");
  }, [selected]);

  function changeSelected(value) {
    if (value !== "one") {
      setTooltipVisible(false);
    }

    if (value !== selected) {
      document.getElementById(selected).classList.remove("selected");
      document
        .getElementById("medal-block")
        .classList.remove(selected + "-img");

      setSelected(value);
    }
  }

  return (
    <div className="section so-good-section" id="marble">
      <div className="gf-bg">
        <img src={gfBackground} alt="" />
      </div>
      <div className="section-title so-good-title">
        <div>{texts.titles.marmore[index]}</div>

        <Fade left big>
          <div className="line-one-sub"></div>
        </Fade>
        <Fade right big>
          <div className="line-two-sub"></div>
        </Fade>
      </div>
      <Fade>
        <div className="section-content so-good-content">
          <div className="div-block">
            <div className="div-numbers">
              <div className="div-number one">
                <button
                  onClick={() => changeSelected("one")}
                  onMouseOver={() => changeSelected("one")}
                  id="one"
                >
                  I
                </button>
              </div>

              <div className="div-number two">
                <button
                  onClick={() => changeSelected("two")}
                  onMouseOver={() => changeSelected("two")}
                  id="two"
                >
                  II
                </button>
              </div>

              <div className="div-number three">
                <button
                  onClick={() => changeSelected("three")}
                  onMouseOver={() => changeSelected("three")}
                  id="three"
                >
                  III
                </button>
              </div>

              <div className="div-number four">
                <button
                  onClick={() => changeSelected("four")}
                  onMouseOver={() => changeSelected("four")}
                  id="four"
                >
                  IV
                </button>
              </div>

              <div className="div-number five">
                <button
                  onClick={() => changeSelected("five")}
                  onMouseOver={() => changeSelected("five")}
                  id="five"
                >
                  V
                </button>
              </div>

              <div className="div-number six">
                <button
                  onClick={() => changeSelected("six")}
                  onMouseOver={() => changeSelected("six")}
                  id="six"
                >
                  VI
                </button>
              </div>

              <Tooltip
                placement="right"
                title={texts.tooltip[index]}
                defaultVisible={true}
                mouseLeaveDelay={0}
                visible={tooltipVisible}
              >
                <div className="div-number seven">
                  <button
                    onClick={() => changeSelected("seven")}
                    onMouseOver={() => changeSelected("seven")}
                    id="seven"
                  >
                    VII
                  </button>
                </div>
              </Tooltip>
            </div>

            <div className="div-img">
              <img src={imgBlock} alt="Feature" className="img-block" />
            </div>
          </div>

          <div className="block-feature">
            <div className="feature-medal medal-block" id="medal-block"></div>

            <div className="text">
              {selected === "one" ? (
                <p>
                  {texts.block[selected][index][0]}
                  <span style={{ fontWeight: "bold", fontSize: "1.15em" }}>
                    {texts.block[selected][index][1]}
                  </span>

                  {texts.block[selected][index][2]}
                  <span style={{ fontWeight: "bold", fontSize: "1.15em" }}>
                    {texts.block[selected][index][3]}
                  </span>
                  {texts.block[selected][index][4]}
                </p>
              ) : (
                <p>{texts.block[selected][index]}</p>
              )}
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default MarbleComponent;
